import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import type { PersonalAssistantManagementComponent } from '../personal-assistant-management.component';

@Component({
  selector: 'assistant-create-wizard',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzModalModule,
    NzSpinModule,
    NzTagModule,
    I18nPipe,
    TestIdDirective
  ],
  templateUrl: './assistant-create-wizard.component.html',
  styleUrls: ['./assistant-create-wizard.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AssistantCreateWizardComponent {
  @Input({ required: true }) vm!: PersonalAssistantManagementComponent;
}
